<template>
    <div id="main">
        <loader v-if="isLoading"/>
        <div class="page page-container">
            <alert-container :messages="msgs" />
            <div class="novo-lote">
                <h1 class="title">
                    {{ $t("lote") }}:
                    {{
                        !lote.idlote
                            ? $t("novo-lote")
                            : lote.descricao
                    }}
                </h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{
                                $t("vendas")
                            }}</a>
                        </li>
                        <li>
                            <a class="a-inativo">{{
                                $t("produto")
                            }}</a>
                        </li>
                        <li>
                            <a @click="redirectToPage">{{
                                $t("lote")
                            }}</a>
                        </li>
                        <li>
                            <a aria-current="page">{{
                                !lote.idlote
                                    ? $t("novo-lote")
                                    : lote.descricao
                            }}</a>
                        </li>
                    </ul>
                </nav>
                <div class="form-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="redirectToPage"
                    >
                        {{ $t("voltar") }}
                    </button>
                    <button
                        v-if="
                            ((!isUpdate && permissao.create) ||
                                (isUpdate && permissao.update)) &&
                            !integracao
                        "
                        class="save-btn"
                        type="button"
                        @click="saveLote()"
                        :disabled="isSaving"
                    >
                        {{ $t("salvar") }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2 mt-3">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="lote.idloteerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!lote.idloteerp"
                            />
                        </div>
                        <div class="column mt-3">
                            <v-input
                                v-model="lote.descricao"
                                :id="generateId(2)"
                                :placeholder="'preencha'"
                                :maxlength="50"
                                :title="'descricao'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!lote.descricao"
                                ref="descricaoInput"
                                required
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                        <div class="situacao-input column is-one-quarter mt-3">
                            <vss-select
                                :id="generateId(3)"
                                ref="situacaoSelect"
                                :options="situacoes"
                                v-model="situacao"
                                @input="updateSituacao"
                                :disabled="!isUpdate"
                                title="situacao"
                                required
                                tooltipLabel="info-situacao-generica"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoteService from "@/services/LoteService";
import LoteValidation from "@/services/validations/LoteValidation";
import Message from "@/models/Message";

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged && this.flag === 0) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    data() {
        return {
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes("LOTE"),
            isSaving: false,
            lote: {
                idlote: null,
                idloteerp: null,
                descricao: null,
                situacao: 1,
            },
            editable: false,
            title: "",
            msgs: [],
            situacao: { label: this.$t("ativo"), id: 3 },
            situacoes: [
                { label: this.$t("ativo"), id: 3 },
                { label: this.$t("inativo"), id: 2 },
            ],
            isUpdate: false,
            isChanged: false,
            flag: 0,
            service: null,
            isLoading: false,
        };
    },
    watch:{
        lote:{
            deep: true,
            handler: function () {
                this.isChanged = true;
            }
        }
    },
    created() {
        if (this.lote != null && this.lote != {}) {
            this.editable = true;
        }

        this.service = new LoteService(this.$http, this.$router);
        this.validation = new LoteValidation(this.msgs);

        this.permissao = 
            this.hasPermissionAccess(
                "vendas",
                "produtos",
                "ven-produto-lote"
            )
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "lote" },
            });
        } else {
            this.isUpdate = this.$route.params.id ? true : false;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: "acesso-nao-permitido",
                    params: { tela: "lote" },
                });
            }

            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    methods: {
        generateId(numberId){
            return this.$route.name+'-'+numberId;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        carregarDados(id) {
                this.isLoading = true;
                this.service
                    .find(id)
                    .then((body) => {
                        if (body.content) {
                            this.lote = body.content;
                            this.title = this.lote.descricao;
                            this.getSituacao();
                        } else {
                            this.$router.push({
                                name: "ven-produto-lote-new"
                            });
                        }
                    })
                    .catch((e) => {
                        console.error("Erro ao carregar lote.", e);
                        this.msgs.push(
                            new Message("error", "msg-erro-load-lote", true)
                        );
                    })
                    .finally((_) => {
                        this.isChanged = false;
                    });
                this.isLoading = false;
        },
        getSituacao() {
            let temp = this.situacoes.find((s) => s.id == this.lote.replicapda);
            if (temp != undefined) this.situacao = temp;
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.lote.replicapda = situacao.id;
                this.situacao = situacao;
            }
        },
        saveLote(redirect = this.redirectToPage) {
            if(this.validation.validate(this.lote, this.$refs)){
            this.flag = 1;
            this.isSaving = true;
            this.lote.descricao = this.mapTosave(this.lote.descricao);
            this.service.save(this.lote)
                .then((body) => {
                    if (body.content) {
                        let msg = "msg-save-lote-sucesso";
                        if (this.lote.idlote) {
                            msg = "msg-edit-lote-sucesso";
                        }
                        this.lote = body.content;
                        this.msgs.push(
                            new Message("success", msg, true)
                        );
                        this.isChanged = false;
                        redirect(2);
                    } else {
                        this.isSaving = false;
                        let message = body.message;
                        if (message && this.$te(message)) {
                            if (message == "msg-codigo-duplicado-n") {
                                this.msgs.push(new Message(
                                    'alert', 
                                    this.$t(message, { n: this.lote.idloteerp }), 
                                    true, 
                                    false
                                ));
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }

                            return;
                        }

                        this.msgs.push(
                            new Message('error', 'msg-problema-realizar-acao', true)
                        );
                    }
                })
                .catch((e) => {
                    this.flag = 0;
                    this.msgs.push(
                        new Message(
                            "error",
                            "msg-problema-realizar-acao",
                            true
                        )
                    );
                    console.error(e)
                    this.isSaving = false;
                });
            }
        },
        redirectToPage() {
            let tempTela = null;
            let tempAba = null;
            let id = this.$route.query['id'];

            this.isChanged = false;
            
            if(this.$route.query.tela == 'produto-lote'){
                tempTela = 'ven-produto-dados-cadastrais-edit';
                setTimeout(() => {
                    this.$router.push({
                        name: tempTela,
                        params: { 
                            id: id
                        },
                        query: { 
                            dadoscadastrais: this.$route.query.dadoscadastrais,
                            politicacomercial: this.$route.query.politicacomercial,
                            analisecomercial: this.$route.query.analisecomercial,
                        },
                    });
                }, 1000);
            }else{
                tempTela = "ven-produto-lote-list";
                setTimeout(() => {
                    this.$router.push({
                        name: tempTela,
                        params: { id: id, name: this.$route.query.name },
                        query: tempAba ? {abaSelecionada: tempAba  } : null,
                    });
                }, 1000);
            }
        },
    }
};
</script>

<style lang="scss" scoped>
#main {
    height: auto;
    padding: 0 20px;

    .page {
        position: relative;
        margin-bottom: 80px;
    }
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}

</style>
